import * as Yup from "yup";

export const featureValidation = Yup.object().shape({
  value: Yup.string().required("وارد کردن مقدار الزامی است"),
  title: Yup.string().required("وارد کردن عنوان الزامی است"),
});
